/**
 * CSV文字列をファイルとしてダウンロードする
 * @param fileName ダウンロードするファイル名
 * @param csvText CSV文字列
 * @return ダウンロード処理の完了
 */
export const downloadCsvFile = (fileName: string, csvText: string) => {
  // ファイル名に使用できない文字を置換して安全なファイル名を生成する
  // <>:"/\\|?* と制御文字を _ に置換し、末尾の . とスペースを削除する
  const sanitizeDownloadFileName = (fileName: string) => {
    const replacedInvalidCharacters = Array.from(fileName, (char) => {
      const charCode = char.charCodeAt(0);

      if (/[<>:"/\\|?*]/.test(char) || charCode < 0x20) {
        return "_";
      }

      return char;
    }).join("");

    const sanitized = replacedInvalidCharacters.replace(/[. ]+$/g, "").trim();

    return sanitized || "download.csv";
  };

  const blob = new Blob(["\uFEFF", csvText], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");

  link.href = url;
  link.download = sanitizeDownloadFileName(fileName);
  link.click();

  URL.revokeObjectURL(url);
};
